"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Validates if a value is null (=== null).
 *
 * @export
 * @class IsNullValidator
 * @implements {PropertyValidator<any>}
 */
class IsNullValidator {
    isValid(input) {
        return input === null;
    }
}
exports.IsNullValidator = IsNullValidator;
//# sourceMappingURL=IsNullValidator.js.map